import { transparentize } from 'polished'
import styled from 'styled-components'

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => transparentize(0.75, theme.static['gray-1000'])};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 8888;
`

export const ModalContent = styled.div<{ width: number; height: number; border: string; background: string }>`
    position: relative;
    background: ${({ theme, background }) => background || theme['gray-0']};
    border: ${({ theme, border, background }) => border || `2px solid ${background || theme['gray-0']}`};
    border-radius: 5px;
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    z-index: 9999;
`

export const ModalClose = styled.div`
    position: absolute;
    right: -30px;
    top: 14px;
    cursor: pointer;
`
